import React, { useState } from 'react'
import {
  TextField,
  Button,
  Typography,
  Box,
} from "@mui/material";
import { Link } from "react-router-dom";
import image from "../../assets/forgot-password4.png";
import { Grid } from '@mui/material';
import axiosInstance from '../../utils/axiosInstance';
import { toast } from 'react-toastify';
import { useFormik } from 'formik';
import * as Yup from "yup";
import logo from "../../assets/logo.png"

const ForgotPassword = () => {

  const validationSchema = Yup.object({

    email: Yup.string()
      .required("Email is required")
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "Enter a valid email address"
      ),
  });
  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      try {
        const payload = {
          username: values.email
        }
        const response = await axiosInstance.post('/users/password-recovery', payload);
        console.log("register response", response);

        if (response.status === 200) {
          toast.success("Mail sent successfully");
        }
      } catch (error) {
        console.error(error);
      }
    },
  });


  return (
    <Box  >
      <Grid
        container
        className="d-flex justify-content-center align-items-center vh-100 my-0 gap-3 login-main-wrapper"
      >
        <Box
          component="form"
          onSubmit={formik.handleSubmit}
          className='login-wrapper'
        >
          <Box className="setting-icon mb-1" display={"flex"} justifyContent={"center"} >
            <img src={logo} alt="app-logo" loading="lazy" />
          </Box>
          <Typography variant="h5" gutterBottom className='text-center'>
            Forgot Password
          </Typography>
          <TextField
            fullWidth
            required
            id="email"
            name="email"
            label="Email"
            type="email"
            margin="normal"
            variant="outlined"
            value={formik.values.email}
            // onChange={formik.handleChange}
            onChange={(e) => {
              const lowerCaseEmail = e.target.value.toLowerCase();
              formik.setFieldValue("email", lowerCaseEmail);
            }}
            onBlur={formik.handleBlur}
            error={formik.touched.email && Boolean(formik.errors.email)}
            helperText={formik.touched.email && formik.errors.email}
          />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            className='mt-3'
            disabled={!(formik.dirty && formik.isValid) || formik.isSubmitting}
          >
            Send Email
          </Button>
          <Typography variant="body1" className='mt-3 text-center auth-label-wrapper' >
            Remember your password?  <Link to="/login" className="router-link-color">Login here</Link>
          </Typography>
        </Box>
        {/* <Grid item size={{ lg: 3, md: 6, sm: 12, xs: 12 }}>
          <Box
            component="form"
            onSubmit={formik.handleSubmit}
          >
            <Typography variant="h4" gutterBottom>
              Forgot Password
            </Typography>
            <TextField
              fullWidth
              required
              id="email"
              name="email"
              label="Email"
              type="email"
              margin="normal"
              variant="outlined"
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.email && Boolean(formik.errors.email)}
              helperText={formik.touched.email && formik.errors.email}
            />
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              className='mt-3'
              disabled={!(formik.dirty && formik.isValid) || formik.isSubmitting}
            >
              Send Email
            </Button>
            <Typography variant="body1" className='mt-2'>
              Remember your password?  <Link to="/login" className="router-link-color">Login here</Link>
            </Typography>
          </Box>
        </Grid>
        <Grid item size={{ lg: 4, md: 6, sm: 12, xs: 12 }}>
          <Box
            component="img"
            src={image}
            alt="Register"
            className='w-100 h-auto'
          />
        </Grid> */}
      </Grid>
    </Box>
  )
}

export default ForgotPassword